import { useEffect } from 'react';

import './index.css'

import MainBanner from './components/MainBanner';
import Carousel from '../../../utils/Carousel';
// import Timer from './components/Timer';
// import RegButton from './components/RegButton';
import AboutSection from './components/AboutSection';
import Stages from './components/Stages';
import Prizing from './components/Prizing';
import TimeLine from './components/TimeLine';
import GuideLines from './components/GuideLines';
import FAQSection from './components/FAQSection';


import scrollToTop from '../../../../utility/scrollToTop';

import { eventIndexConstants } from './../../../../utility/event-details'
import eventsDetails from '../../../../utility/event-details';

const TechnoGrad23 = () => {
    useEffect(() => {
        scrollToTop();
    }, []);

    const event = eventsDetails[eventIndexConstants.TECHNOGRAD23]

    function mouseHover(e) {
        const letter = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        let iterations = 0;

        const interval = setInterval(() => {
            e.target.innerText = e.target.innerText.split("").map((letters, index) => {
                if (index < iterations) {
                    return e.target.dataset.value[index];
                }
                return letter[Math.floor(Math.random() * 26)]
            })
                .join("")

            if (iterations >= e.target.dataset.value?.length) clearInterval(interval);

            iterations += 1;
        }, 70);
    }

    return (
        <div id='techno-grad-wrapper'>
            <MainBanner mouseHover={mouseHover} />
            <div className="tg23-carousel-wrapper">
                <Carousel images={event.images} />
            </div>
            {/* <Timer mouseHover={mouseHover} />
			<RegButton mouseHover={mouseHover} /> */}
            <AboutSection mouseHover={mouseHover} />
            <Stages mouseHover={mouseHover} />
            <Prizing mouseHover={mouseHover} />
            <TimeLine mouseHover={mouseHover} />
            <GuideLines mouseHover={mouseHover} />
            <FAQSection mouseHover={mouseHover} />
        </div>
    )
}

export default TechnoGrad23